import { getApi } from "../api";

// Fetch payment history for a specific user
export const fetchPaymentHistory = async (userId) => {
	try {
		const response = await getApi(`/payment/user/${userId}`);
		return response; // Return the payment history data
	} catch (error) {
		throw new Error(
			`Error fetching payment history: ${
				error.response?.data?.message || error.message
			}`
		);
	}
};
